// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel } from './extEnrollmentMoveMemberNumberBySurveyQuestionResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModel"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.attributeTypeMap;
    }
}
